// TODO: Find a way so that `jquery-settings` is only imported when jQuery is needed on the page,
//   and to ensure that it loads before any jQuery code is run.
//   https://github.com/paperculture/easel/pull/2/files#r636564077
import '@/jquery-settings'
import { initialize } from '@/zendesk/webWidget'

export const initTier2Common = async (): Promise<void> => {
  // Don't wait for Zendesk to load and initialize because it may be deferred
  initialize()
}
